<template>
  <div :class="`${prefixDatePickClass}__time-panel`">
    <!--header-->
    <div :class="`${prefixDatePickClass}__header`">
      <span v-if="isOnlyTimeType">{{ title }}</span>
      <span v-else v-text="picked"></span>
    </div>
    <!--body-->
    <t-time-scroll
      v-if="isOnlyTimeType"
      ref="timeScroll"
      :hour="hourValue"
      :minute="minuteValue"
      :picked="picked"
      :min-select-range="minSelectRange"
      :max-select-range="maxSelectRange"
      :format="format"
      :hours="hours"
      :minutes="minutes"
      @pick="onPickTime"
    >
    </t-time-scroll>
    <div v-else :class="`${prefixDatePickClass}__body clearfix`">
      <ul :class="`${prefixClass}__title`">
        <li>{{ t('t.datepicker.hour') }}</li>
        <li>{{ t('t.datepicker.minute') }}</li>
        <li>{{ t('t.datepicker.second') }}</li>
      </ul>
      <div :class="prefixClass">
        <div :class="`${prefixClass}__select`">
          <ul ref="hours">
            <li v-for="(item, key) in hours" :key="key" @click.stop="setTime($event, 'hours')">
              <a :class="getClass('hour',key)" :index="item.value">{{ item.label }}</a>
            </li>
            <li v-for="index in 6" :key="'hour' + index" class="blank" @click.stop></li>
          </ul>
        </div>
        <div :class="`${prefixClass}__select`">
          <ul ref="minutes">
            <li v-for="(item, key) in minutes" :key="key" :index="item.value" @click.stop="setTime($event, 'minutes')">
              <a :class="getClass('minute',key)" :index="item.value">{{ item.label }}</a>
            </li>
            <li v-for="index in 6" :key="'minute' + index" class="blank" @click.stop></li>
          </ul>
        </div>
        <div :class="`${prefixClass}__select`">
          <ul ref="seconds">
            <li v-for="(item, key) in seconds" :key="key" :index="item.value" @click.stop="setTime($event, 'seconds')">
              <a :class="getClass('second',key)" :index="item.value">{{ item.label }}</a>
            </li>
            <li v-for="index in 6" :key="'second' + index" class="blank" @click.stop></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import locale from '@/mixins/locale'
import TTimeScroll from './time-scroll'

import {
  PREFIX_DATE_PICK_CLASS,
  PREFIX_TIME_SPINNER_CLASS,
  CLASS_DISABLED
} from '../constants'

export default {
  name: 'TTimeSpinner',
  components: {
    TTimeScroll
  },
  mixins: [locale],
  props: {
    hour: {
      type: Number,
      default: 0
    },
    minute: {
      type: Number,
      default: 0
    },
    second: {
      type: Number,
      default: 0
    },
    showSeconds: {
      type: Boolean,
      default: true
    },
    picked: {
      type: String,
      default: ''
    },
    minSelectRange: {
      type: Object,
      default: () => {}
    },
    maxSelectRange: {
      type: Object,
      default: () => {}
    },
    isOnlyTimeType: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: 'HH:mm:ss'
    }
  },
  data: function() {
    return {
      prefixDatePickClass: PREFIX_DATE_PICK_CLASS,
      prefixClass: PREFIX_TIME_SPINNER_CLASS,
      hours: [],
      minutes: [],
      seconds: [],
      hourValue: '',
      minuteValue: '',
      secondValue: '',
      formatter: moment()
    }
  },
  computed: {
    // 仅类型为 time 时使用的面板标题，该标题文本将随时分秒的变化而变化
    title() {
      // return `${this.hourValue}:${this.minuteValue}:${this.secondValue}`
      return this.formatter.hour(this.hourValue).minute(this.minuteValue).second(this.secondValue).format(this.format)
    }
  },
  watch: {
    hour(val) {
      this.hourValue = val
    },
    minute(val) {
      this.minuteValue = val
    },
    second(val) {
      this.secondValue = val
    }
  },
  created() {
    this.hourValue = this.hour
    this.minuteValue = this.minute
    this.secondValue = this.second
    this.determineTime()
  },
  methods: {
    getClass(key, val) {
      let _classes = []
      if (this[key] !== undefined && this[key] === val) {
        _classes.push(`${PREFIX_TIME_SPINNER_CLASS}--selected`)
      }
      if (this.picked) {
        let _pickDate = moment(this.picked, 'YYYY/MM/DD')
        if (this.minSelectRange && _pickDate.isSame(this.minSelectRange, 'date')) {
          let _hour = this.hour || this.minSelectRange.hour()
          let _minute = this.minute || this.minSelectRange.minute()
          let _second = this.second || this.minSelectRange.second()
          let _pickerTime = moment(`${this.picked} ${key === 'hour' ? val : _hour}:${key === 'minute' ? val : _minute}:${key === 'second' ? val : _second}`, 'YYYY/MM/DD HH:mm:ss')
          if (_pickerTime.isBefore(this.minSelectRange, key)) {
            _classes.push(CLASS_DISABLED)
          }
        }
        if (this.maxSelectRange && _pickDate.isSame(this.maxSelectRange, 'date')) {
          let _hour = this.hour || this.maxSelectRange.hour()
          let _minute = this.minute || this.maxSelectRange.minute()
          let _second = this.second || this.maxSelectRange.second()
          let _pickerTime = moment(`${this.picked} ${key === 'hour' ? val : _hour}:${key === 'minute' ? val : _minute}:${key === 'second' ? val : _second}`, 'YYYY/MM/DD HH:mm:ss')
          if (_pickerTime.isAfter(this.maxSelectRange, key)) {
            _classes.push(CLASS_DISABLED)
          }
        }
      }
      return _classes
    },
    determineTime() {
      // init hour
      for (let i = 0; i < 24; i++) {
        let key = i < 10 ? '0' + i : i
        this.hours.push({ label: key, value: i })
      }
      // init minute，second
      for (let i = 0; i < 60; i++) {
        let key = i < 10 ? '0' + i : i
        this.minutes.push({ label: key, value: i })
        this.seconds.push({ label: key, value: i })
      }
    },
    updateTime(type, timeIndex) {
      if (type === 'hours') {
        this.hourValue = timeIndex
      } else if (type === 'minutes') {
        this.minuteValue = timeIndex
      } else if (type === 'seconds') {
        this.secondValue = timeIndex
      }
    },
    setTime(event, type) {
      if (event.target.className.indexOf(CLASS_DISABLED) > -1) {
        return
      }
      let index = event.target.getAttribute('index')
      let top = event.target.offsetTop
      this.$refs[type].scrollTop = top < 0 ? 0 : top
      this.updateTime(type, parseInt(index))
      this.$emit('pick', type.substr(0, type.length - 1), parseInt(index))
    },
    ajustScrollTop(hour = this.hour, minute = this.minute, second = this.second) {
      let vm = this
      if (this.picked && !hour && !minute && !second) {
        let _pickerTime = moment(this.picked, 'YYYY/MM/DD')
        if (this.minSelectRange && this.minSelectRange.isSame(_pickerTime, 'date')) {
          hour = vm.minSelectRange.hour()
          minute = vm.minSelectRange.minute()
          second = vm.minSelectRange.second()
        }
        if (this.maxSelectRange && this.maxSelectRange.isSame(_pickerTime, 'date')) {
          hour = vm.maxSelectRange.hour()
          minute = vm.maxSelectRange.minute()
          second = vm.maxSelectRange.second()
        }
      }
      if (!this.isOnlyTimeType) {
        vm.$nextTick(function() {
          const _height = 32
          let hourTop = hour * _height
          vm.$refs.hours.scrollTop = hourTop
          let minuteTop = minute * _height
          vm.$refs.minutes.scrollTop = minuteTop
          let secondTop = second * _height
          vm.$refs.seconds.scrollTop = secondTop
        })
      } else {
        this.$refs.timeScroll.$_setScrollTop()
      }
    },
    onPickTime (type, value) {
      this.$emit('pick', type, value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/date-picker/basic/time-spinner.vue